import { render } from "./EditDishModalComponent.vue?vue&type=template&id=e448201c&scoped=true"
import script from "./EditDishModalComponent.vue?vue&type=script&lang=js"
export * from "./EditDishModalComponent.vue?vue&type=script&lang=js"

import "./EditDishModalComponent.vue?vue&type=style&index=0&id=e448201c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e448201c"]])

export default __exports__